import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({ selector: '[telephoneFormatter]' })
export class TelephoneNumberFormatDirective {

  private el: HTMLInputElement;

  constructor( private elementRef: ElementRef ) {
    this.el = this.elementRef.nativeElement;
  }

  @HostListener('keyup', ['$event.target.value'])
  onKeyUp(value) {
    const trimValue = value.replace(/[^0-9|\\+]/g, '');
    if (trimValue.length > 7) {
      this.el.value = trimValue.replace(/(\d{2})(\d{4})(\d{1,})/, '$1 $2 $3');
    } else {
      this.el.value = trimValue.replace(/(\d{2})(\d{1,})/, '$1 $2');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/register/telephoneNumberFormat.directive.ts